import { combineReducers } from "redux";
import authReducer from "./auth/authSlice";
import commonReducer from "./common/commonSlice";
import cartReducer from "./cart/cart";

const rootReducer = combineReducers({
  authReducer,
  commonReducer,
  cartReducer
});

export default rootReducer;
